import { render, staticRenderFns } from "./multDetail.vue?vue&type=template&id=b0631158&scoped=true&"
import script from "./multDetail.vue?vue&type=script&lang=js&"
export * from "./multDetail.vue?vue&type=script&lang=js&"
import style0 from "./multDetail.vue?vue&type=style&index=0&id=b0631158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0631158",
  null
  
)

export default component.exports